import { useMutation, useQuery } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ApiError, StateMachineFireRequest, StateMachineFireResponse, StateMachineDefinitionResponse } from '../types/showcase';

/**
 * C066 상태 머신 데모 (queue #646 §R646-2/§R646-3).
 * GET .../state-machine/definition — 전이 정의(다이어그램용) 자동 조회.
 * POST .../state-machine/fire — 사용자가 현재상태+이벤트 선택 → 실행(useMutation).
 */

export function useStateMachineDefinition() {
  return useQuery<StateMachineDefinitionResponse, ApiError>({
    queryKey: ['common-showcase', 'state-machine', 'definition'],
    queryFn: () => showcaseApi.stateMachineDefinition(),
    staleTime: 60_000,
  });
}

export function useStateMachineFire() {
  return useMutation<StateMachineFireResponse, ApiError, StateMachineFireRequest>({
    mutationFn: (req) => showcaseApi.stateMachineFire(req),
    mutationKey: ['common-showcase', 'state-machine', 'fire'],
  });
}
